<template>
    <div class="c-card-list">
        <CardTable
                :caption="caption"
                :onRowClick="onRowClick"
                :onColumnClick="onColumnClick"
                :onCellClick="onCellClick"
                :onPageClick="onPageClick"
                :options="options"
                :pagination="pagination"
                :rows="rows"
                :columns="columns">
            <slot slot="cardTableHeaderActions">
                <slot name="cardTableHeaderActions"></slot>
            </slot>
        </CardTable>
    </div>
</template>
<script>
    import CardTable from './CardTable'
    export default {
        extends: CardTable,
        name: 'CardList',
        components: {
            CardTable
        },
        props: {
        },
        watch: {
            rows(val) {
                this.dataRows = val
                this.setActions()
            },
            columns: {
                handler(val) {
                    this.dataColumns = val
                    this.setActions()
                },
                deep: true
            }
        },
        mounted() {
            this.dataRows = this.rows
        },
        data: function () {
            return {
                dataRows: [],
                dataActions: []
            }
        },
        methods: {
            addAction(key, callBack, columnLabel, value, columnClasses, columnStyles) {
                this.dataActions.push(
                    {
                        columnLabel: columnLabel,
                        key: key,
                        columnClasses: columnClasses,
                        columnStyles: columnStyles,
                        value: value,
                        callBack: callBack
                    }
                )
            },
            setActions() {
                for(let action in this.dataActions) {
                    action = this.dataActions[action]
                    if (action.key !== undefined) {
                        let columnIsExist = window.Core.Array.findByKey(this.dataColumns, 'key', action.key)
                        if (!columnIsExist) {
                            let column = {
                                label: action.columnLabel,
                                key: action.key,
                                classes: action.columnClasses,
                                styles: action.columnStyles
                            }
                            this.dataColumns.push(column)
                        }
                        for(let rowIndex in this.dataRows) {
                            if (this.dataRows[rowIndex][action.key] === undefined || this.dataRows[rowIndex][action.key] == true) {
                                let row = {
                                    value: action.value,
                                    callBack: action.callBack
                                }
                                this.dataRows[rowIndex][action.key] = row
                            }
                        }
                    }
                }
            }
        }
    }
</script>

